<template>
  <div style="width:100%">
    <div style="padding:20px">
      <el-button type="primary" @click="initAdd">添加模板</el-button>

      <el-table
          :data="templates"
          :stripe="true"
          :current-page.sync="currentPage"  v-loading="loading">
        <el-table-column label="模板名" prop="template_name"></el-table-column>
        <el-table-column label="主题" prop="test_subject"></el-table-column>
        <el-table-column label="所属业务" prop="test_BU"></el-table-column>
        <el-table-column label="所属项目" prop="project_code"></el-table-column>
        <el-table-column label="类型" prop="test_type"></el-table-column>
        <el-table-column label="满分" prop="full_score" width="80px"></el-table-column>
        <el-table-column label="单题分数" prop="question_marks" width="80px"></el-table-column>
        <el-table-column label="考试时长" prop="test_duration" width="80px"></el-table-column>
        <el-table-column label="题目数量" prop="question_counts" width="80px"></el-table-column>
        <el-table-column label="材料数量" prop="pic_arr_counts" width="80px"></el-table-column>
        <el-table-column label="操作" width="220px">
          <template slot-scope="scope">
            <el-button type="primary" @click="edit(scope.row._id.$id)" size="small">编辑</el-button>
            <el-button type="danger" @click="remove(scope.row._id.$id)" size="small">删除</el-button>
            <el-button type="primary" @click="exportTemplate(scope.row)" size="small">导出</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <el-dialog
        title="编辑模板"
        :close-on-click-modal="false"
        width="60%"
        :visible.sync="showTemplate"
    >
      <el-form
          class="block-form"
          :model="diaForm"
          ref="innerdialogForm"
          :rules="rules"
          @open="openDialog"
          @close="closeDialog"
          status-icon
          label-width="100px"
          size="medium"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="模板名" prop="template_name">
              <el-input placeholder="请输入模板名" type="text" v-model="diaForm.template_name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="试卷所属业务" prop="test_BU">
              <el-select class="w140" v-model="diaForm.test_BU" placeholder="请选择试卷所属业务" clearable>
                <el-option
                    v-for="item in BUOptions"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="试卷所属项目代码" prop="project_code">
              <el-select v-model="diaForm.project_code" style="width: 300px" @change="handleProjectCodeChanged">
                <el-option v-for="(project,index) in projects" :value="project.project_code"
                           :label="project.project_code" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="试卷类型" prop="test_type">
              <el-select class="w140" v-model="diaForm.test_type" placeholder="请选择试卷类型" clearable>
                <el-option
                    v-for="item in typeOptions"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="主题" prop="">
              <el-select v-model="diaForm.test_subject" style="width: 400px" @change="handleSubjectChanged">
                <el-option v-for="item in event_award_modes" :key="item" :value="item"
                           :label="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="主题(自定义)" prop="">
              <el-input placeholder="请填写自定义主题" type="text" v-model="custom_test_subject"></el-input>
              <p>优先取自定义主题，如果自定义主题没有设置，就取选择的主题</p>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="介绍" prop="template_instruction">
              <el-input placeholder="请填写介绍" type="text" v-model="diaForm.template_instruction"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="时长" prop="test_duration">
              <el-input placeholder="请填写时长" type="text" v-model="diaForm.test_duration"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="满分" prop="full_score">
              <el-input placeholder="请填写满分分值" type="number" v-model="diaForm.full_score"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="单题分值" prop="question_marks">
              <el-input placeholder="请填写单题分值" type="number" v-model="diaForm.question_marks"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="考试时间" prop="test_time">
              <el-input placeholder="请填写时间" type="text" v-model="diaForm.test_time"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="createExerciseTemplate('diaForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showExport" :close-on-click-modal="false">
      <p>字体</p>
          <el-select v-model="exportForm.font">
            <el-option v-for="item in fontList" :key="item" :value="item"></el-option>
          </el-select>
      <p>页边距</p>
          <el-input v-model.number="exportForm.margin">
            <template slot="append">px</template>
          </el-input>
      <p>前言</p>
          <Tinymce v-model="exportForm.preface" :height="240"></Tinymce>
      <p>封面图片</p>
          <el-upload
                class="avatar-uploader"
                action="/"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload">
                <img v-if="exportForm.export_cover" :src="exportForm.export_cover" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
      <el-button @click="confirmExport" type="primary">确认导出</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { createExerciseTemplate, getExerciseTemplates, getProjects, removeExerciseTemplate, getQiniuToken, addExportInfo } from '../api/examAdmin'
import Tinymce from '../components/Tinymce'
import * as qiniu from 'qiniu-js'
export default {
  components: {
    Tinymce
  },
  data () {
    return {
      custom_test_subject: '',
      event_award_modes: [],
      projects: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      templates: [],
      diaForm: {},
      rules: {},
      showTemplate: false,
      BUOptions: [
        {
          name: 'AM'
        },
        {
          name: 'ETA'
        },
        {
          name: 'FBLA'
        },
        {
          name: 'FBLC'
        },
        {
          name: 'Envirothon'
        },
        {
          name: 'CEC'
        },
        {
          name: 'FELC'
        },
        {
          name: 'WEC'
        },
        {
          name: 'IBO'
        },
        {
          name: 'CEO'
        },
        {
          name: 'IPSYO'
        },
        {
          name: 'WAO'
        },
        {
          name: 'ICS'
        }

      ],
      typeOptions: [
        {
          name: 'formal_test'
        },
        {
          name: 'mock_test'
        },
        {
          name: 'sample_test'
        },
        {
          name: 'special_exercise'
        }
      ],
      exportForm: {
        font: '',
        preface: '',
        margin: '',
        export_cover: ''
      },
      fontList: [
        'Arial',
        'Arial Black',
        'Verdana',
        'Tahoma',
        'Trebuchet MS',
        'Impact',
        'Times New Roman',
        'Didot',
        'Georgia',
        'American Typewriter',
        'Andalé Mono',
        'Courier',
        'Lucida Console',
        'Monaco',
        'Bradley Hand',
        'Brush Script MT',
        'Luminari',
        'Comic Sans MS',
        '华文细黑',
        '华文黑体',
        '华文楷体',
        '华文宋体',
        '华文仿宋',
        '俪黑 Pro',
        '俪宋 Pro',
        '标楷体',
        '苹果俪中黑',
        '苹果俪细宋'
      ],
      currentTemplate: null,
      showExport: false,
      loading: false
    }
  },
  mounted () {
    this.fetchData()
    this.requestProjects()
  },
  methods: {

    handleSubjectChanged (e) {
      this.$forceUpdate()
    },

    handleProjectCodeChanged (e) {
      this.event_award_modes = []
      this.diaForm.test_subject = ''
      this.custom_test_subject = ''
      for (let i = 0; i < this.projects.length; i++) {
        if (this.projects[i].project_code == this.diaForm.project_code) {
          if (this.projects[i].event_number_string) {
            const event_award_modes_string = this.projects[i].event_number_string
            const values = event_award_modes_string.split('\r\n')
            for (let j = 0; j < values.length; j++) {
              this.event_award_modes.push(values[j].split('|')[0])
            }
          }
          break
        }
      }
    },

    async requestProjects () {
      const resut1 = await getProjects('22-23')
      const resut2 = await getProjects('23-24')
      this.projects = resut2.data.concat(resut1.data)
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    fetchData () {
      this.loading = true
      getExerciseTemplates({ page: this.currentPage, page_size: this.pageSize }).then(res => {
        if (res.data.code === 0) {
          this.templates = res.data.data
          this.total = (res.data.total !== undefined) ? res.data.total : this.templates.length
        }
      }).finally(() => {
        this.loading = false
      })
    },
    initAdd () {
      this.event_award_modes = []
      this.showTemplate = true
    },
    createExerciseTemplate () {
      let test_subject = this.custom_test_subject// this.diaForm.test_subject
      if (!test_subject || test_subject == '' || test_subject == undefined || test_subject == null) {
        test_subject = this.diaForm.test_subject
      }
      const params = {
        template_id: '',
        template_name: this.diaForm.template_name,
        test_subject: test_subject,
        template_instruction: this.diaForm.template_instruction,
        test_duration: this.diaForm.test_duration,
        test_type: this.diaForm.test_type,
        test_BU: this.diaForm.test_BU,
        test_time: this.diaForm.test_time,
        project_code: this.diaForm.project_code,
        full_score: this.diaForm.full_score,
        question_marks: this.diaForm.question_marks
      }
      createExerciseTemplate(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.showTemplate = false
          this.fetchData()
        }
      })
    },
    edit (id) {
      this.$router.push({
        path: '/templateInfo',
        query: {
          template_id: id
        }
      })
    },
    openDialog () {
      // 打开弹框
      this.$nextTick(() => {
        if (this.$refs.diaForm) {
          this.$refs.diaForm.clearValidate()
        }
      })
    },
    closeDialog () {
      this.diaForm = {}
    },
    remove (id) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        removeExerciseTemplate(id).then(res => {
          if (res.data.code === 0) {
            this.$message('删除成功')
            this.fetchData()
          }
        })
      })
    },
    exportTemplate (row) {
      this.showExport = true
      this.currentTemplate = row
      this.exportForm.margin = this.currentTemplate.margin ? this.currentTemplate.margin : ''
      this.exportForm.font = this.currentTemplate.font ? this.currentTemplate.font : ''
      this.exportForm.preface = this.currentTemplate.preface ? this.currentTemplate.preface : ''
      this.exportForm.export_cover = this.currentTemplate.export_cover ? this.currentTemplate.export_cover : ''
    },
    confirmExport () {
      addExportInfo({
        template_id: this.currentTemplate._id.$id,
        font: this.exportForm.font,
        preface: this.exportForm.preface,
        margin: this.exportForm.margin,
        export_cover: this.exportForm.export_cover
      }).then(res => {
        if (res.data.code === 0) {
          this.fetchData()
          const url = this.$router.resolve({
            path: '/print',
            query: {
              id: this.currentTemplate._id.$id
            }
          })
          window.open(url.href, '_blank')
        }
      })
    },
    async beforeAvatarUpload (file) {
      const result = await getQiniuToken()
      if (result.data.code === 0) {
        const token = result.data.data
        this.observable = qiniu.upload(
          file,
          new Date().getTime() + file.name,
          token
        )
        const observer = {
          complete: (res) => {
            this.$set(this.exportForm, 'export_cover', 'http://mainbucket.reachable-edu.com/' + res.key)
          }
        }
        this.observable.subscribe(observer)
      }
    }
  }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px!important;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
